export const BOND_PAYLOAD_KIND_CONFIG = {
  guardianship: {
    bondType: 3,
    getBondSubCategory: (state) => state.basicInformation?.bondSubCategory,
    nestedKey: 'guardianshipbond',
    principalsKey: 'guardians',
    principalCountField: 'GuardianNumber',
    nameStrategy: 'personName',
    retrieveArgOrder: 'standard',
    createIsEsignatures: false,
    retrieveUsesNestedBuilder: true,
  },
  va: {
    bondType: 6,
    getBondSubCategory: () => 'None',
    nestedKey: 'vabond',
    principalsKey: 'principals',
    principalCountField: 'PrincipalNumber',
    nameStrategy: 'personName',
    retrieveArgOrder: 'standard',
    createIsEsignatures: (state) => state.basicInformation?.is_esignatures === 'Yes',
    retrieveUsesNestedBuilder: true,
  },
  probate: {
    bondType: 1,
    getBondSubCategory: (state) => state.basicInformation?.bondSubCategory,
    nestedKey: 'probatebond',
    principalsKey: 'personal_rep',
    principalCountField: 'PrincipalNumber',
    nameStrategy: 'personName',
    retrieveArgOrder: 'statusFirst',
    createIsEsignatures: (state) => state.basicInformation?.is_esignatures === 'Yes',
    retrieveUsesNestedBuilder: true,
  },
  trustee: {
    bondType: 4,
    getBondSubCategory: (state) => state.basicInformation?.bondSubCategory,
    nestedKey: 'trustee_bond',
    principalsKey: 'trustees',
    principalCountField: 'PrincipalNumber',
    nameStrategy: 'legalName',
    retrieveArgOrder: 'statusFirst',
    createIsEsignatures: (state) => state.basicInformation?.is_esignatures === 'Yes',
    retrieveUsesNestedBuilder: true,
  },
};

export const getBondPayloadKindConfig = (kind) =>
  BOND_PAYLOAD_KIND_CONFIG[kind] ?? null;

/**
 * Principal/guardian count for retrieve PATCH and approve payloads.
 * Guardianship retrieval uses GuardianNumber; other bond types use PrincipalNumber.
 */
export function getRetrievePrincipalCount(basicInformation, kind) {
  const kindConfig = getBondPayloadKindConfig(kind);
  const field =
    kindConfig?.principalCountField ||
    FIDUCIARY_NESTED_VARIANTS[kind]?.countField ||
    "PrincipalNumber";
  const parsed = Number(basicInformation?.[field]);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}

export const FIDUCIARY_NESTED_VARIANTS = {
  guardianship: {
    subjectPrefix: 'ward',
    fiduciaryPrefix: 'guardian',
    principalsPluralPrefix: 'guardians',
    subjectDobField: 'dateOfDeath',
    countField: 'GuardianNumber',
    businessField: 'fiduciary_operate_wards_business',
    indebtedField: 'guardian_indebited_to_estate',
    indebtedExplanationField: 'guardian_indebted_explanation',
  },
  va: {
    subjectPrefix: 'beneficiary',
    fiduciaryPrefix: 'principal',
    principalsPluralPrefix: 'principals',
    subjectDobField: 'dateOfBirth',
    countField: 'PrincipalNumber',
    businessField: 'fiduciary_operate_beneficiarys_business',
    indebtedField: 'principal_indebted_to_estate',
    indebtedExplanationField: 'principal_indebted_explanation',
  },
};
